import { h } from "preact";

const TwoCols = ({ children, leftStyle }) => {
  return (
    <div class="columns two-cols" style={{ height: "100%" }}>
      <div style={leftStyle} class="column left-col">{children[0]}</div>
      <aside class="column right-col">{children[1]}</aside>
    </div>
  );
};
export default TwoCols;



// WEBPACK FOOTER //
// ./components/TwoCols.js